"use client";
import { onlineManager } from "@tanstack/react-query";
import { useSyncExternalStore } from "react";

export function useIsOnline() {
	const online = useSyncExternalStore(
		(onStoreChange) => {
			return onlineManager.subscribe(() => onStoreChange());
		},
		() => onlineManager.isOnline(),
		() => onlineManager.isOnline(),
	);
	return online;
}
